<div class="pageWrapper supplier-oms">
  <div class="formsDetails rfq">
    <section class="oms-upper-section">
      <span routerLink="/oms/orders">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
        </svg>
      </span>
      <h3 class="page-title">Order Management</h3>
    </section>

    <div class="list_dtl">
      <div>
        <div>
          <div class="rfq_lst_dtl">
            <mat-card class="rfq-card">
              <div class="oms-card-top flex">
                <div class="flex">
                  <span class="oms-po-id">P.O ID : </span>
                  <span class="po-id">{{ orderDetail?.poId }}</span>
                  <span class="po-template">{{ orderDetail?.rfqTemplateType }}</span>
                </div>
                <div class="flex">
                  <span class="oms-status">{{ getEdpStatusLabel(orderDetail?.customerEdp?.edpStatus) }}</span>
                </div>
              </div>
              <mat-card-header>
                <div class="rfq-title-expiry">
                  <mat-card-title class="matToolCss" matTooltip="{{ orderDetail?.projectName }}">
                    {{ orderDetail?.projectName }}</mat-card-title
                  >
                  <mat-card-subtitle>
                    <span class="small-font">Order Date : </span>
                    <span class="light-font"> {{ orderDetail?.orderDate }} </span>
                  </mat-card-subtitle>
                </div>
                <div class="rfq-capabilities">
                  <h5 class="rfq-category cate">Category</h5>
                  <!-- <ng-container>
                    <span class="capability" *ngFor="let cat of orderDetail?.categories">
                      {{ cat.name }}
                    </span>
                  </ng-container> -->
                  <ng-container *ngFor="let cat of (orderDetail?.categories | categoryFormatter: 2).display">
                    <span class="capability" [matTooltip]="(orderDetail?.categories | categoryFormatter: 2).tooltip">
                      {{ cat }}
                    </span>
                  </ng-container>
                </div>
                <div class="rfq-capabilities">
                  <h5 class="rfq-category cate">Total Quantity</h5>
                  <h5 class="rfq-category">{{ orderDetail?.totalQuantity }}</h5>
                </div>
              </mat-card-header>
              <div class="flex detail_box">
                <div class="rfq-capabilities">
                  <h5 class="rfq-category cate">Due Date</h5>
                  <h5 class="rfq-category due-date">
                    {{ orderDetail?.dueDate | date: "MMM d, y" }}
                  </h5>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
      </div>

      <span class="milestones">Milestones</span>
      <div
        *ngIf="
          [EDPStatus.EDP_RECEIVED, EDPStatus.EDP_RETURN, EDPStatus.EDP_APPROVED].includes(orderDetail?.customerEdp?.edpStatus);
          else edpData
        "
      >
        <mat-accordion *ngFor="let mile of orderDetail?.customerEdp?.customerMilestones; index as index">
          <mat-expansion-panel [disabled]="mile.state == 'SKIP'">
            <mat-expansion-panel-header #panelH (click)="panelH._toggle()">
              <mat-panel-title>
                <mat-checkbox
                  class="example-margin"
                  (change)="checkMilestones($event.checked, index, mile.id)"
                  [checked]="mile['freezeCheckbox']"
                  [disabled]="true"
                >
                </mat-checkbox>
                <div class="file_name">{{ mile.milestoneName }}</div>
              </mat-panel-title>
              <mat-panel-description>
                <div class="date">
                  <span class="date_label">Start Date</span>
                  <mat-form-field appearance="outline">
                    <input
                      id="modules_rfqmodule_rfqquote_28"
                      matInput
                      [matDatepicker]="picker1"
                      placeholder="MM/DD/YYYY"
                      [(ngModel)]="mile.startDate"
                      [min]="yesterday"
                      (dateChange)="selectedDate($event)"
                      (click)="openDatePicker(picker1)"
                      [value]="yesterday"
                      [disabled]="true"
                    />
                    <mat-datepicker #picker1></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="date">
                  <span class="date_label">End Date</span>
                  <mat-form-field appearance="outline">
                    <input
                      id="modules_rfqmodule_rfqquote_28"
                      matInput
                      [matDatepicker]="picker2"
                      placeholder="MM/DD/YYYY"
                      [(ngModel)]="mile.endDate"
                      (click)="openDatePicker(picker2)"
                      [min]="yesterday"
                      (dateChange)="selectedDate($event)"
                      [disabled]="true"
                    />
                    <mat-datepicker #picker2></mat-datepicker>
                  </mat-form-field>
                </div>

                <div
                  class="flex comment_box btn_dtl feedback"
                  (click)="viewCommentSection($event, mile?.id, mile.milestoneName, entityType.MILESTONE)"
                >
                  <span class="comment_icon">
                    <lucide-icon name="message-square" class="lucid-icon"></lucide-icon>
                  </span>
                  <span [ngClass]="{ active: !getCommentStatus(mile?.id) }"></span>
                </div>
              </mat-panel-description>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        </mat-accordion>

        <!-- <div class="flex detail comment_detail" *ngIf="orderDetail?.customerEdp.customerEdpChats.length != 0">
          <div class="comment_area col-sm-12" *ngFor="let mileChats of orderDetail?.customerEdp.customerEdpChats">
            <ng-container *ngIf="mileChats?.commentBy == 'by'">
              <h3>My Remarks</h3>
              <div class="comment_text admin">
                <h4>
                  {{ mileChats?.commentBy }}
                  <span> {{ mileChats?.createdOn | date: "MMM d, y" }}</span>
                </h4> 
                <p>{{ mileChats?.comment }}</p>
              </div>
            </ng-container>

            <ng-container *ngIf="mileChats?.commentBy == 'by'">
              <h3>Comment Received from Unibuild</h3>
              <div class="comment_text supplier">
                <h4>
                  {{ mileChats?.commentBy }}
                  <span> {{ mileChats?.createdOn | date: "MMM d, y" }}</span>
                </h4>
                <p>{{ mileChats?.comment }}</p>
              </div>
            </ng-container>
          </div>
        </div> -->
      </div>
      <ng-template #edpData>
        <p class="no-result-container flex">EDP Status is pending</p>
      </ng-template>
    </div>
  </div>
  <div class="bottom-btn btn-outline" *ngIf="false">
    <button
      mat-button
      class="btnCustom btn-outline"
      *ngIf="orderDetail?.customerEdp?.edpStatus == EDPStatus.EDP_RECEIVED"
      (click)="redirectToReturn()"
    >
      Return
    </button>
    <button
      mat-button
      class="btnCustom btn-primary"
      *ngIf="[EDPStatus.EDP_RECEIVED, EDPStatus.EDP_RETURN].includes(orderDetail?.customerEdp?.edpStatus)"
      (click)="approveEdp()"
    >
      Approve
    </button>
  </div>
</div>

<div class="commentbox-overlayDrop" *ngIf="commentPanelActive" (click)="closeCommentSection($event)"></div>
<div class="commentbox-layout-rightpanel" [ngClass]="{ 'commentbox-layout-rightpanel-active': commentPanelActive }">
  <app-comment-sidenav
    [baseUrl]="baseUrl"
    [metaData]="metaData"
    [entityId]="entityId"
    [milestoneName]="milestoneName"
    (childClick)="closeCommentSection($event)"
  ></app-comment-sidenav>
</div>
